import type { Aircraft } from '@/shared/types'
import { AIRPORTS } from './airports'

const TYPES: { type: string; cat: Aircraft['category']; baseHours: number }[] = [
  { type: 'Su-30MK2', cat: 'fighter', baseHours: 1200 },
  { type: 'Su-22M4', cat: 'fighter', baseHours: 4500 },
  { type: 'Su-27SK', cat: 'fighter', baseHours: 3800 },
  { type: 'MiG-21Bis', cat: 'fighter', baseHours: 5200 },
  { type: 'Yak-130', cat: 'trainer', baseHours: 800 },
  { type: 'L-39C', cat: 'trainer', baseHours: 3100 },
  { type: 'Mi-8', cat: 'helicopter', baseHours: 4200 },
  { type: 'Mi-17', cat: 'helicopter', baseHours: 2400 },
  { type: 'Mi-171', cat: 'helicopter', baseHours: 1100 },
  { type: 'C-295M', cat: 'transport', baseHours: 1800 },
  { type: 'CASA C-212', cat: 'transport', baseHours: 6800 },
  { type: 'An-26', cat: 'transport', baseHours: 8500 },
  { type: 'DHC-6', cat: 'transport', baseHours: 1200 },
]

const STATUSES: Aircraft['status'][] = ['ready', 'ready', 'ready', 'in-flight', 'maintenance', 'inspection', 'reserve']

function pad(n: number, w: number): string {
  return String(n).padStart(w, '0')
}

function generateAircraft(): Aircraft[] {
  const list: Aircraft[] = []
  let counter = 1
  TYPES.forEach((t, tIdx) => {
    const count = t.cat === 'fighter' ? 4 : t.cat === 'helicopter' ? 3 : 2
    for (let i = 0; i < count; i++) {
      const idx = counter++
      const airport = AIRPORTS[(tIdx + i) % AIRPORTS.length]
      const totalHours = t.baseHours + i * 110 + (idx % 13) * 7
      const hoursToInsp = 100 - (totalHours % 100)
      const status = STATUSES[idx % STATUSES.length]
      const tail = `${78}${pad(tIdx, 2)}${pad(i + 1, 2)}`
      const year = 2008 + (idx % 16)
      list.push({
        id: `ac-${idx}`,
        code: `${t.type.split(/[\s-]/)[0]}-${pad(idx, 3)}`,
        tailNumber: tail,
        type: t.type,
        category: t.cat,
        unitId: airport.unitId,
        baseAirportId: airport.id,
        totalHours,
        hoursToInspection: hoursToInsp,
        status,
        manufactureYear: year,
        lastInspectionDate: `2026-${pad(((idx + 2) % 12) + 1, 2)}-${pad(((idx * 3) % 28) + 1, 2)}`,
        nextInspectionDate: `2026-${pad(((idx + 6) % 12) + 1, 2)}-${pad(((idx * 5) % 28) + 1, 2)}`,
      })
    }
  })
  return list
}

export const AIRCRAFT: Aircraft[] = generateAircraft()
export const AIRCRAFT_BY_ID: Record<string, Aircraft> = Object.fromEntries(
  AIRCRAFT.map((a) => [a.id, a]),
)
